import { CircularProgress, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { bodyFont } from '../../../../Theme';

export default () => {
    const { t } = useTranslation('translations', { keyPrefix: 'sidepanel' });

    return (
        <Stack direction='row' justifyContent='center'>
            <CircularProgress size={1} />
            <Typography sx={{ ...bodyFont, fontSize: 14 }}>{t('loading')}</Typography>
        </Stack>
    );
};
